export function useEnvironment(): Environment {
  const vercelEnv = import.meta.env.VITE_PUBLIC_VERCEL_ENV as 'production' | 'staging' | undefined
  if (!vercelEnv) {
    return 'local'
  } else if (vercelEnv === 'production') {
    return 'live'
  } else {
    return vercelEnv
  }
}
